// extracted by mini-css-extract-plugin
export default {"authLayout":"index_authLayout__GIqP3"};